/**
 * Products translations: domains, domain, tldCatalog, cart, forms
 */

import { VSERVER_SMTP_BLOCK_DATE } from '@/legal/vserverSmtpBlockDate'

export const domains = {
  check: {
    eyebrow: 'Domain registrieren',
    title: 'Deine Domain, direkt mit deinem Stack verbunden',
    subtitle:
      'Durchsuche 500+ TLDs zu transparenten Preisen pro Endung — und richte deine neue Domain direkt auf dein Hosting, deine Mail oder dein Kubernetes-Ingress aus, alles im selben Panel. Kein Nameserver-Gefummel.',
    toCart: 'Zum Warenkorb',
    searchAriaLabel: 'Domain-Suche',
    popular: {
      title: 'Beliebte Domain-Endungen',
      subtitle:
        'Preise pro Jahr, inkl. MwSt. Registrierung, Verlängerung und Transfer für alle 500+ Endungen findest du in der TLD-Übersicht.',
      cta: 'Alle Endungen und Preise ansehen'
    },
    included: {
      title: 'Bei jeder Domain dabei',
      dnsTitle: 'DNS-Verwaltung im Panel',
      dnsDesc: 'Records ändern, ohne ein Ticket zu schreiben',
      dyndnsTitle: 'Wildcard-DynDNS inklusive',
      dyndnsDesc: 'ein Eintrag für alle Subdomains',
      instantTitle: 'Sofort-Registrierung',
      instantDesc: 'bei den meisten Endungen in Minuten aktiv',
      integratedTitle: 'Direkt verbunden',
      integratedDesc: 'Hosting, Mail oder Kubernetes-Ingress, alles im selben Panel',
      addon:
        'Optional dazubuchbar bei unterstützten Endungen: WHOIS-Schutz — versteckt deine persönlichen Daten in der öffentlichen WHOIS-Abfrage.'
    },
    transfer: {
      title: 'Deine Domain liegt noch woanders?',
      body: 'Zieh sie mit deinem Auth-Code zu ITSH um und verwalte Domain, DNS und Verlängerung künftig im selben Panel wie deinen Stack. Transferpreise pro Endung findest du in der TLD-Übersicht.',
      cta: 'Transfer starten'
    }
  },
  search: {
    singlePlaceholder: 'Wunschdomain eingeben (z.B. mustermann oder mustermann.de)',
    singlePlaceholderShort: 'Wunschdomain eingeben',
    multiPlaceholder: 'Domains eingeben (eine pro Zeile)\nz.B. mustermann.de\nbeispiel.com:AUTHCODE',
    multiHint: 'Unterstützt: Zeilenumbruch, Komma, Semikolon · Max. {max}',
    statsDetected: 'Erkannt: {count}',
    statsInvalid: 'Ungültig: {count}',
    statsDuplicates: 'Duplikate entfernt: {count}',
    statsLimitReached: 'Limit erreicht ({max})',
    multicheck: 'Multicheck',
    uploadFile: 'Datei hochladen',
    allTlds: 'Alle TLDs',
    format: 'Formatieren',
    clear: 'Leeren',
    checkDomain: 'Domain prüfen'
  },
  trust: {
    nis2: {
      title: 'Geprüfte Kontaktdaten',
      subtitle: 'nach NIS2 Art. 28'
    },
    eu: {
      title: 'EU-Registrar',
      subtitle: 'Verwaltung in der EU'
    }
  },
  band: {
    priceFrom: 'ab',
    perYear: '/Jahr',
    checkDomain: 'Domain prüfen',
    enterDomain: 'Domain-Name eingeben',
    selectDomain: '.{tld} Domain auswählen, ab {price} pro Jahr',
    defaultDomain: 'meinedomain'
  },
  tlds: {
    de: 'Deutschland',
    com: 'International',
    eu: 'Europa',
    at: 'Österreich',
    ch: 'Schweiz',
    net: 'Network',
    germany: 'Deutschland',
    international: 'International',
    europe: 'Europa',
    austria: 'Österreich',
    switzerland: 'Schweiz',
    network: 'Network'
  },
  results: {
    filters: {
      freeOnly: 'Nur freie Domains',
      allExtensions: 'Alle Endungen',
      extension: 'Endung',
      sort: 'Sortieren',
      relevance: 'Relevanz',
      priceAsc: 'Preis aufsteigend',
      priceDesc: 'Preis absteigend',
      extensionAZ: 'Endung A–Z'
    },
    selection: {
      hits: '{count} Treffer',
      selected: '{count} ausgewählt',
      selectAllVisible: 'Alle sichtbaren auswählen',
      clearSelection: 'Auswahl löschen',
      registerCount: '{count} registrieren',
      freeDomainsSelected: '{count} freie Domains ausgewählt',
      register: 'Registrieren'
    },
    categories: {
      yourDomain: 'Deine Wunschdomain',
      searchResults: 'Suchergebnisse',
      domainHacks: 'Domain-Hacks',
      creativeAlternatives: 'Kreative Alternativen',
      popularExtensions: 'Beliebte Endungen',
      additionalFreeExtensions: 'Weitere freie Endungen'
    },
    moreFree: {
      searchMore: 'Mehr freie Endungen suchen',
      allChecked: 'Alle {count} TLDs wurden geprüft'
    },
    checkingMore: 'Weitere Endungen werden geprüft …',
    tableHeaders: {
      domain: 'Domain',
      status: 'Status',
      price: 'Preis',
      authToken: 'Auth-Token',
      action: 'Aktion'
    },
    addedToCart: 'Zum Warenkorb hinzugefügt',
    addedToCartMessage: '{count} Domain wurde dem Warenkorb hinzugefügt | {count} Domains wurden dem Warenkorb hinzugefügt',
    pricing: {
      inclVat: 'alle Preise inkl. MwSt',
      exclVat: 'alle Preise zzgl. MwSt'
    },
    idn: {
      invalidChars: 'Ungültige Zeichen für .{tld}',
      invalidCharsDetail: 'Die Zeichen „{chars}" sind für .{tld}-Domains nicht erlaubt.',
      notSupported: '.{tld} unterstützt keine Sonderzeichen',
      allowedChars: 'Erlaubte Sonderzeichen: {chars}',
      skippedDomains:
        '{count} Domain mit ungültigen Zeichen übersprungen | {count} Domains mit ungültigen Zeichen übersprungen',
      filteredHint: 'Einige Endungen unterstützen keine Sonderzeichen und werden ggf. nicht angezeigt.'
    },
    validation: {
      invalidTitle: 'Ungültige Domain',
      invalidMessage: 'Bitte gib einen gültigen Domainnamen ein, z. B. „example" oder „example.com".',
      noResultsTitle: 'Keine Ergebnisse',
      noResultsMessage: 'Für deine Suche wurden keine Domains gefunden. Bitte versuche einen anderen Namen.'
    }
  }
} as const

export const domain = {
  config: {
    title: 'Domain konfigurieren',
    perYear: 'Jahr',
    year: 'Jahr',
    contacts: 'Kontakte',
    contactsHint: 'Optional: Wähle Inhaber- und Admin-Kontakt für diese Domain.',
    owner: 'Inhaber',
    admin: 'Admin',
    selectHandle: 'Kontakt auswählen...',
    addons: 'Zusatzoptionen',
    whoisProtection: 'WHOIS-Schutz',
    whoisProtectionDesc: 'Versteckt deine persönlichen Daten in der öffentlichen WHOIS-Abfrage.',
    trusteeService: 'Treuhänder-Service',
    trusteeDesc: 'Diese TLD erfordert einen Admin-Kontakt mit Wohnsitz im Zielland. Der Treuhänder übernimmt diese Funktion für dich.',
    viewContract: 'Treuhandvertrag ansehen',
    total: 'Gesamt',
    addToCart: 'In den Warenkorb',
    alreadyInCart: 'Bereits im Warenkorb',
    alreadyInCartMessage: '{domain} ist bereits im Warenkorb.',
    addedToCart: 'Hinzugefügt',
    addedToCartMessage: '{domain} wurde dem Warenkorb hinzugefügt.'
  }
} as const

export const tldCatalog = {
  eyebrow: 'Domain-Endungen',
  title: 'TLD Übersicht',
  subtitle: 'Alle verfügbaren Domain-Endungen mit aktuellen Preisen. Wähle deine TLDs und prüfe die Verfügbarkeit deiner Wunschdomain.',
  instantRegistration: 'Sofort-Registrierung',
  whoisProtection: 'WHOIS-Schutz optional',
  loading: 'TLDs werden geladen...',
  loadMore: 'Mehr TLDs laden',
  categories: {
    all: 'Alle Kategorien',
    generic: 'Generic TLDs',
    cctld: 'Länderdomains (ccTLDs)',
    newGtld: 'Neue gTLDs',
    other: 'Sonstige'
  },
  filters: {
    category: 'Kategorie',
    search: 'TLD suchen',
    searchPlaceholder: 'z.B. de, com, berlin...',
    promoOnly: 'Nur Aktions-TLDs',
    maxPrice: 'Max. Preis',
    noLimit: 'Alle',
    showing: '{count} von {total} TLDs'
  },
  pricing: {
    registration: 'Registrierung',
    renewal: 'Verlängerung',
    transfer: 'Transfer'
  },
  selection: {
    count: '{count} von {max} TLDs ausgewählt',
    placeholder: 'Domain-Name eingeben',
    check: 'Prüfen',
    clear: 'Auswahl löschen'
  },
  empty: {
    title: 'Keine TLDs gefunden',
    description: 'Versuche eine andere Suche oder wähle eine andere Kategorie.'
  },
  errors: {
    loadFailed: 'TLDs konnten nicht geladen werden.',
    invalidData: 'Ungültige Daten vom Server.'
  }
} as const

export const cart = {
  title: 'Warenkorb',
  itemCount: '{count} Artikel',
  loading: 'Warenkorb wird geladen...',
  saveError: {
    title: 'Fehler',
    message: 'Dein Warenkorb konnte nicht gespeichert werden. Bitte versuche es erneut.'
  },
  mailErrors: {
    alreadySubscribed: 'Für diese Domain ist E-Mail-Hosting bereits gebucht oder schon im Warenkorb.',
    includedInHosting: 'E-Mail ist für diese Domain schon in deinem Hosting-Paket enthalten. Du musst nichts buchen.',
    adminHold: 'E-Mail für diese Domain wurde von uns gesperrt und kann nicht gebucht werden. Bitte wende dich an den Support.',
    domainSuspended: 'Die Domain ist gesperrt. E-Mail-Hosting kannst du erst buchen, wenn die Sperre aufgehoben ist.',
    domainDeleted: 'Die Domain wurde gelöscht. Stelle sie zuerst wieder her, dann kannst du E-Mail-Hosting buchen.',
    heldElsewhere: 'Die Domain gehört bei uns einem anderen Kundenkonto. E-Mail-Hosting dafür kann nur dieses Konto buchen.',
    domainUnavailable:
      'Für diesen Namen kannst du hier kein E-Mail-Hosting buchen: Er gehört zu einer Domain eines anderen Kontos oder ist keine eigene Domain. Wenn es deine Domain ist, wende dich an den Support.'
  },
  categories: {
    webhosting: 'Webhosting',
    domains: 'Domains',
    kubernetes: 'Kubernetes',
    vserver: 'VServer',
    email: 'E-Mail Hosting',
    other: 'Sonstiges'
  },
  item: {
    paymentInterval: 'Zahlungsweise',
    pricePerMonth: 'Preis pro Monat',
    pricePerQuarter: 'Preis pro Quartal',
    pricePerHalfYear: 'Preis pro Halbjahr',
    pricePerYear: 'Jahrespreis',
    total: 'Gesamt',
    oneTime: 'Einmalig',
    unitPrice: 'Stückpreis',
    price: 'Preis',
    pricePending: 'wird berechnet',
    remove: 'Entfernen'
  },
  summary: {
    title: 'Zusammenfassung',
    monthly: 'Monatlich',
    quarterly: 'Vierteljährlich',
    halfYearly: 'Halbjährlich',
    yearly: 'Jährlich',
    net: 'Netto',
    vat: 'MwSt. {rate}%',
    dueTodayGross: 'Sofort fällig (Brutto)',
    dueToday: 'Sofort fällig',
    pricesIncludeTax: 'Alle Preise inkl. MwSt.',
    pricesExcludeTax: 'Alle Preise zzgl. MwSt.',
    reverseChargeNote:
      'Nettopreise. Steuerschuldnerschaft des Leistungsempfängers: Die Umsatzsteuer schuldest du in deinem Land (Reverse Charge).',
    notTaxableNote: 'Nettopreise. Die Leistung ist in Deutschland nicht steuerbar, deshalb berechnen wir keine Umsatzsteuer.',
    vatExemptNotice: 'Gem. § 19 UStG wird keine USt berechnet',
    acceptTerms: 'Ich akzeptiere die',
    terms: 'AGB',
    /**
     * § 356 Abs. 5 BGB lets the right of withdrawal lapse on complete
     * performance only after two declarations: an express request for early
     * performance and confirmed knowledge of the lapse. No Wertersatz is
     * claimed on withdrawal (AGB § 12.5), so the text announces none.
     */
    withdrawalConsent:
      'Ich verlange ausdrücklich, dass Sie vor Ablauf der Widerrufsfrist mit der Ausführung der Leistung beginnen. Mir ist bekannt, dass mein Widerrufsrecht erlischt, sobald Sie die Leistung vollständig erbracht haben.',
    withdrawalConsentDomains:
      'Mir ist bekannt, dass die Registrierung einer Domain mit dem Eintrag bei der Registrierungsstelle vollständig erbracht ist und mein Widerrufsrecht insoweit mit der Registrierung erlischt.',
    withdrawalPolicy: 'Widerrufsbelehrung',
    mailSendLimitNote:
      'E-Mail Hosting: In den ersten 30 Tagen ab Registrierung des Kundenkontos gelten reduzierte Versandlimits von 30 Nachrichten pro Stunde und 100 pro Tag je Postfach. Nachrichten darüber hinaus gehen nicht verloren, sondern werden vorübergehend abgewiesen und verbleiben im E-Mail-Programm; je nach Programm wird die Zustellung automatisch wiederholt. Danach gelten die regulären Limits. Details in § 5 der Service-Vereinbarungen E-Mail Hosting.',
    termContract: 'Laufzeit',
    termIndefinite: 'Unbestimmte Laufzeit, keine Mindestlaufzeit. Jederzeit kündbar; die Kündigung wirkt einen Monat nach Zugang, bei einem VServer sofort. Im Voraus bezahlte Zeit danach erstatten wir anteilig.',
    termDomain: 'Unbestimmte Laufzeit, jederzeit kündbar mit Wirkung einen Monat nach Zugang, bei einem VServer sofort. Die Registrierungsperiode (meist 12 Monate) kaufen wir bei der Registrierungsstelle im Voraus; ihr Entgelt wird nicht erstattet, die Domain bleibt bis zu ihrem Ende bestehen.',
    termNoticeLabel: 'Kündigung',
    termNotice: 'Jederzeit über „Verträge hier kündigen“ oder das Kundenportal',
    submitOrder: 'Zahlungspflichtig bestellen'
  },
  checkout: {
    acceptTerms: 'Ich akzeptiere die',
    terms: 'AGBs',
    withdrawalConsent:
      'Ich verlange ausdrücklich, dass Sie vor Ablauf der Widerrufsfrist mit der Ausführung der Leistung beginnen. Mir ist bekannt, dass mein Widerrufsrecht erlischt, sobald Sie die Leistung vollständig erbracht haben.',
    withdrawalConsentDomains:
      'Mir ist bekannt, dass die Registrierung einer Domain mit dem Eintrag bei der Registrierungsstelle vollständig erbracht ist und mein Widerrufsrecht insoweit mit der Registrierung erlischt.',
    withdrawalPolicy: 'Widerrufsbelehrung',
    mailSendLimitNote:
      'E-Mail Hosting: In den ersten 30 Tagen ab Registrierung des Kundenkontos gelten reduzierte Versandlimits von 30 Nachrichten pro Stunde und 100 pro Tag je Postfach. Nachrichten darüber hinaus gehen nicht verloren, sondern werden vorübergehend abgewiesen und verbleiben im E-Mail-Programm; je nach Programm wird die Zustellung automatisch wiederholt. Danach gelten die regulären Limits. Details in § 5 der Service-Vereinbarungen E-Mail Hosting.',
    termContract: 'Laufzeit',
    termIndefinite: 'Unbestimmte Laufzeit, keine Mindestlaufzeit. Jederzeit kündbar; die Kündigung wirkt einen Monat nach Zugang, bei einem VServer sofort. Im Voraus bezahlte Zeit danach erstatten wir anteilig.',
    termDomain: 'Unbestimmte Laufzeit, jederzeit kündbar mit Wirkung einen Monat nach Zugang, bei einem VServer sofort. Die Registrierungsperiode (meist 12 Monate) kaufen wir bei der Registrierungsstelle im Voraus; ihr Entgelt wird nicht erstattet, die Domain bleibt bis zu ihrem Ende bestehen.',
    termNoticeLabel: 'Kündigung',
    termNotice: 'Jederzeit über „Verträge hier kündigen“ oder das Kundenportal',
    submitOrder: 'Zahlungspflichtig bestellen',
    paymentsDisabled:
      'Online-Zahlungen sind derzeit nicht verfügbar. Bitte versuche es später erneut.',
    loginRequired: 'Bitte melde dich an oder registriere dich, um fortzufahren.',
    newRegistration: 'Neu registrieren',
    or: 'oder',
    errors: {
      cartPaid: 'Dieser Warenkorb wurde bereits bezahlt. Deine Bestellung findest du unter „Käufe“.',
      cartChanged: 'Der Warenkorb hat sich während des Bezahlens geändert. Bitte prüfe ihn und versuche es erneut.',
      cartBusy: 'Für diesen Warenkorb läuft gerade eine Bezahlung. Bitte versuche es in einem Moment erneut.',
      productUnavailable: 'Ein Produkt in deinem Warenkorb kann nicht bestellt werden. Bitte entferne es aus dem Warenkorb.',
      periodUnavailable: 'Diese Zahlungsweise ist für E-Mail-Hosting nicht verfügbar. Lade die Seite neu und versuche es noch einmal.',
      threeDSFailed: '3DS-Authentifizierung fehlgeschlagen',
      cardDeclined: 'Deine Karte wurde abgelehnt. Bitte versuche eine andere Zahlungsmethode.',
      insufficientFunds: 'Deine Karte ist nicht ausreichend gedeckt. Bitte versuche eine andere Zahlungsmethode.',
      expiredCard: 'Deine Karte ist abgelaufen. Bitte aktualisiere deine Zahlungsmethode.',
      paymentDeclined: 'Die Zahlung wurde abgelehnt. Bitte versuche eine andere Zahlungsmethode.',
      paymentMethodRequired: 'Für diese Bestellung brauchst du eine gespeicherte Zahlungsmethode. Bitte hinterlege eine in deinem Konto.',
      paymentSetupUnavailable: 'Die Zahlung konnte gerade nicht vorbereitet werden. Es wurde nichts abgebucht. Bitte versuche es in einem Moment erneut.',
      vserverTemplateUnavailable: 'Das gewählte Betriebssystem für deinen VServer ist nicht mehr verfügbar. Bitte wähle ein anderes.',
      vserverHostnameInvalid: 'Der Hostname deines VServers ist ungültig. Erlaubt sind Buchstaben, Ziffern, Bindestriche und Punkte, höchstens 63 Zeichen.',
      cartOwnerRequired: 'Dieser Warenkorb gehört zu einem anderen Konto. Bitte melde dich mit diesem Konto an oder beginne einen neuen Warenkorb.',
      cartTooLarge: 'Dein Warenkorb enthält zu viele Positionen. Bitte teile die Bestellung auf.',
      termsReload: 'Seite neu laden',
      termsVersionStale: 'Unsere AGB wurden inzwischen aktualisiert. Lade die Seite neu, lies die aktuelle Fassung und bestätige sie erneut.',
      consentRequired: 'Bitte bestätige die AGB und die Widerrufsbelehrung für den aktuellen Warenkorb erneut.',
      consentVersionRequired: 'Die Fassung der AGB fehlt in deiner Bestellung. Bitte lade die Seite neu und versuche es erneut.',
      avvAcceptanceRequired: 'Für diese Bestellung musst du zuerst den Auftragsverarbeitungsvertrag (AVV) in deinem Konto akzeptieren.'
    }
  },
  validation: {
    title: 'Bitte behebe die folgenden Fehler',
    validating: 'Warenkorb wird geprüft...',
    errors: {
      invalid_domain: 'Ungültiger Domainname',
      incompatible_account_type: 'Kontotyp nicht kompatibel mit dieser TLD',
      missing_handle: 'Kontakt für Domain erforderlich',
      handle_not_verified: 'Für eine Neuregistrierung müssen E-Mail-Adresse und Telefonnummer des Kontakts verifiziert sein.',
      invalid_handle: 'Der gewählte Kontakt kann für diese Domain nicht verwendet werden. Bitte wähle einen anderen.',
      wrong_handle_type: 'Der gewählte Kontakttyp ist für diese Domainendung nicht zulässig.',
      idn_invalid: 'Die Registrierungsstelle akzeptiert die Zeichen in diesem Domainnamen nicht.',
      authcode_required: 'Für den Transfer dieser Domain brauchst du den Auth-Code deines bisherigen Anbieters. Nimm die Domain aus dem Warenkorb und leg sie über die Domainsuche mit dem Code erneut hinein.',
      internal_transfer_authcode_required: 'Für den Transfer dieser Domain brauchst du ihren Auth-Code vom bisherigen Inhaber. Nimm die Domain aus dem Warenkorb und leg sie über die Domainsuche mit dem Code erneut hinein.',
      domain_conflict: 'Diese Domain ist bei uns bereits vergeben und kann nicht für dein Konto bestellt werden.'
    }
  },
  empty: {
    title: 'Dein Warenkorb ist leer',
    description: 'Füge Produkte hinzu, um mit deiner Bestellung zu beginnen.',
    subtitle: 'Entdecke unsere Produkte und finde das passende Angebot für dich.',
    browseDomains: 'Domain suchen',
    browseProducts: 'Produkte entdecken',
    action: 'Produkte entdecken'
  },
  payment: {
    title: 'Zahlung abschließen',
    amountLabel: 'Zu zahlen',
    loading: 'Zahlungsformular wird geladen...',
    validationError: 'Validierungsfehler',
    paymentFailed: 'Zahlung fehlgeschlagen',
    unknownError: 'Unbekannter Fehler',
    securityNote: 'Sichere Zahlung. Deine Kartendaten werden nicht gespeichert.',
    payAmount: '{amount} bezahlen'
  },
  finalizing: {
    processing: {
      title: 'Bestellung wird verarbeitet...',
      subtitle: 'Bitte warte einen Moment.',
      checkingStatus: 'Überprüfe Status...',
      processing_long: 'Deine Zahlung wird gerade bearbeitet. Dies kann einige Sekunden dauern.'
    },
    success: {
      title: 'Zahlung eingegangen!',
      subtitle:
        'Deine Bestellung wird jetzt bearbeitet. Du erhältst eine E-Mail, sobald alles bereit ist.',
      redirecting: 'Weiterleitung in {seconds} Sekunden...',
      viewOrders: 'Bestellungen anzeigen',
      toDashboard: 'Zum Dashboard',
      viewReceipt: 'Beleg anzeigen',
      thankYou: 'Vielen Dank für deine Bestellung!',
      mailDnsHint:
        'Damit E-Mails für {domain} ankommen, müssen noch die DNS-Einträge gesetzt werden.',
      setupMailDns: 'E-Mail-DNS einrichten'
    },
    error: {
      title: 'Ein Fehler ist aufgetreten',
      defaultMessage: 'Bitte versuche es erneut oder kontaktiere den Support.',
      paymentFailed: 'Die Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
      paymentMethodRejected:
        'Die Zahlungsmethode wurde abgelehnt. Bitte wähle eine andere Zahlungsmethode.',
      backToCart: 'Zurück zum Warenkorb',
      toDashboard: 'Zum Dashboard'
    },
    help: {
      text: 'Bei Fragen wende dich an unseren Support unter',
      email: "support{'@'}itsh.de"
    }
  },
  warnings: {
    paymentsDisabled: 'Online-Zahlungen sind derzeit nicht verfügbar.',
    orphanedItems: '{count} Artikel konnte nicht geladen werden. | {count} Artikel konnten nicht geladen werden.',
    removeOrphaned: 'Entfernen'
  },
  phoneVerification: {
    title: 'Telefonnummer bestätigen',
    subtitle: 'Bitte bestätige deine Telefonnummer, um fortzufahren.',
    sendCode: 'Code senden',
    enterCode: 'Code eingeben',
    confirm: 'Bestätigen',
    resend: 'Erneut senden',
    error: 'Code konnte nicht gesendet werden. Bitte versuche es erneut.',
    invalidCode: 'Bitte gib einen 6-stelligen Code ein.',
    wrongCode: 'Ungültiger Code. Bitte versuche es erneut.',
    phoneInUse: 'Diese Telefonnummer ist bereits bei einem anderen Konto verifiziert. Bitte verwende eine eigene Nummer oder kontaktiere den Support.',
    tooManyRequests: 'Zu viele Codes angefordert. Bitte versuche es in einer Stunde erneut.',
    phoneNotMobile: 'Codes per SMS gehen nur an Mobilnummern. Eine Nummer außerhalb von EWR, Schweiz und Großbritannien muss aus deinem eigenen Land sein. Ändere sie in deinen Kontoeinstellungen.',
    smsUnavailable: 'Die Bestätigung per SMS ist gerade nicht verfügbar. Bitte versuche es morgen erneut.',
    tooManyFailures: 'Zu viele falsche Codes. Bitte versuche es morgen erneut.',
    smsDailyLimit: 'Dein Konto hat die Bestätigungs-SMS für heute aufgebraucht. Bitte versuche es morgen erneut.',
    contactChanged: 'Deine Kontaktdaten werden noch aktualisiert. Speichere deine Kontodaten erneut und versuche es dann noch einmal.',
    serviceUnavailable: 'Die Bestätigung ist gerade nicht verfügbar. Bitte versuche es in ein paar Minuten noch einmal.'
  },
  handleWarning: {
    title: 'Verifizierter Kontakt erforderlich',
    subtitle: 'Für die Domain-Registrierung muss E-Mail und Telefon verifiziert sein (NIS2).',
    message: 'Für die Domain-Registrierung ist ein verifizierter Kontakt erforderlich.',
    action: 'Kontakte verifizieren',
    emailVerified: 'E-Mail verifiziert',
    emailMissing: 'E-Mail nicht verifiziert',
    phoneVerified: 'Telefon verifiziert',
    phoneMissing: 'Telefon nicht verifiziert',
    deadlineExpired: 'Verifizierungsfrist abgelaufen',
    deadlineApproaching: 'Verifizierungsfrist läuft ab',
    deadlineExpiredMessage: 'Die Verifizierungsfrist für diese Kontakte ist abgelaufen. Domain-Registrierungen mit diesen Kontakten sind nicht möglich.',
    expired: 'Abgelaufen',
    daysRemaining: '{days} Tage verbleibend'
  },
  secureOnlyNotice: {
    title: 'HTTPS erforderlich',
    message: 'Die folgenden Domains verwenden eine sichere TLD und funktionieren nur mit HTTPS/SSL:'
  },
  sshKey: {
    title: 'SSH-Schlüssel',
    subtitle: 'Wähle den SSH-Schlüssel, mit dem du dich bei deinem Server anmeldest. Optional — du kannst den Zugang auch nach dem Kauf einrichten.',
    addNew: 'Neuer Schlüssel',
    add: 'SSH-Schlüssel hinzufügen',
    empty: 'Du hast noch keinen SSH-Schlüssel hinterlegt. Kein Problem — du kannst den Zugang auch nach dem Kauf im Dashboard einrichten.',
    loading: 'SSH-Schlüssel werden geladen...',
    hint: 'Ohne Schlüssel startet dein Server ohne Zugang — du spielst dann im Dashboard einen Schlüssel ein oder setzt ein Root-Passwort.'
  },
  vserverSmtpNotice: `Ist das dein erster VServer und bestellst du ihn ab dem ${VSERVER_SMTP_BLOCK_DATE.de}, ist ausgehender Port 25 (Zustellung an fremde Mailserver) drei Monate lang gesperrt. Mails über die Submission-Ports 587 und 465 gehen immer.`,
  errors: {
    verificationRequired: {
      title: 'Kontaktverifizierung erforderlich',
      message: 'Für diese Bestellung ist ein vollständig verifizierter Kontakt erforderlich. Bitte verifiziere E-Mail und Telefon deines Kontakts.'
    },
    deadlineExpired: {
      title: 'Verifizierungsfrist abgelaufen',
      message: 'Die Verifizierungsfrist für den verwendeten Kontakt ist abgelaufen. Bitte aktualisiere und verifiziere deine Kontaktdaten erneut.'
    },
    checkout: {
      title: 'Bestellung fehlgeschlagen',
      message: 'Bei der Bestellung ist ein Fehler aufgetreten. Bitte versuche es später erneut.'
    }
  },
  emailVerification: {
    title: 'E-Mail-Bestätigung erforderlich',
    message: 'Wir haben einen Bestätigungslink an {email} gesendet.',
    hint: 'Bitte überprüfe dein Postfach und klicke auf den Link.'
  },
  handleSelector: {
    label: 'Inhaber-Kontakt',
    placeholder: 'Auswählen...',
    owner: 'Inhaber',
    admin: 'Admin',
    noCompatibleHandles: 'Kein kompatibler Kontakt vorhanden',
    errors: {
      requiresOrg: 'Organisation',
      requiresPerson: 'Privatperson',
      incompatibleType: '{tld} erfordert {required}',
      requiresLocal: '{tld} erfordert Kontakt aus {country}',
      companyNeeded: '{tld} erfordert einen Firmenkontakt',
      personNeeded: '{tld} erfordert eine Privatperson'
    }
  },
  pageTitle: 'Warenkorb',
  pageSubtitle: '{count} Artikel',
  items: 'Artikel'
} as const

export const forms = {
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail-Adresse',
  phone: 'Telefon',
  street: 'Straße',
  addressSupplement: 'Adresszusatz',
  postcode: 'PLZ',
  city: 'Stadt',
  state: 'Bundesland',
  country: 'Land',
  organization: 'Organisation',
  vatId: 'Umsatzsteuer-ID',
  iban: 'IBAN',
  bankData: 'Bankdaten',
  ibanPlaceholder: 'DE89 3704 0044 0532 0130 00'
} as const
